import * as React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  shortname: string;
  productCode: string;
}

export const FHCalendar = ({ shortname, productCode }: Props) => {
  const { i18n } = useTranslation();

  const elRef = React.useRef<HTMLDivElement>(null);

  const scriptTag = `<script src="https://fareharbor.com/embeds/script/calendar/${shortname}/items/${productCode}/?fallback=simple&full-items=yes&flow=628748&language=${i18n.language}"></script>`;

  React.useEffect(() => {
    import('postscribe').then(({ default: postscribe }) => {
      if (elRef.current) {
        postscribe(elRef.current, scriptTag);
      }
    });
  }, [scriptTag]);

  return <div ref={elRef}></div>;
};
